import { LogLevel } from "@azure/msal-browser";
import posthog from "posthog-js";
import { B2C_POLICIES } from "../config/constants";

export const MSAL_CONFIG = (email?: string, domainHint?: string) => {
  return {
    msal: {
      auth: {
        clientId: import.meta.env.VITE_CLIENT_ID_B2C as string,
        authority: B2C_POLICIES.authorities.signUpSignIn.authority,
        knownAuthorities: [B2C_POLICIES.authorityDomain],
        redirectUri: `${window.location.origin}/redirectB2C`,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: "localStorage",
      },
      system: {
        loggerOptions: {
          loggerCallback: (
            level: LogLevel,
            message: string,
            containsPii: boolean,
          ) => {
            if (containsPii) return;
            if (level === LogLevel.Error) {
              posthog?.capture("LOGIN_ERROR", { message, email, domainHint });
            }
          },
        },
      },
    },
    login: {
      scopes: [
        `https://${import.meta.env.VITE_AUTH_TENANT}.onmicrosoft.com/${
          import.meta.env.VITE_APPLICATION_ID_B2C
        }/access_as_user`,
      ],
      loginHint: email || "",
      extraQueryParameters: { domain_hint: domainHint || "" },
    },
  };
};

export const getDomainHintFromEmail = (userEmail?: string) => {
  if (userEmail) {
    const domain = userEmail.split("@").pop()?.split(".").shift();
    return domain as string;
  }
  return undefined;
};
